export const BRAND = {
  name: "Abbigliamento Tatiana",
  shortName: "Tatiana",
  city: "Livorno",
  district: "La Scopaia",
  address: "Via Inghilterra 39",
  postalCode: "57128",
  fullAddress: "Via Inghilterra 39, 57128 Livorno",
  phone: "347 0029521",
  phoneRaw: "3470029521",
  whatsapp: "329 1025594",
  whatsappRaw: "393291025594",
  whatsappUrl: "https://wa.me/393291025594?text=Buongiorno%2C%20vorrei%20ricevere%20informazioni%20sui%20vostri%20servizi.",
  facebook: "https://www.facebook.com/profile.php?id=100045208405238",
  instagram: "https://www.instagram.com/lavanderiaabbigliamentotatiana/",
  hoursWinter: [
    { d: "Lun – Ven", h: "08:00 – 12:30  ·  16:30 – 19:30" },
    { d: "Sabato", h: "08:30 – 12:30" },
  ],
  hoursSummer: [
    { d: "Lun – Ven", h: "08:00 – 13:00" },
    { d: "Sabato", h: "08:30 – 12:30" },
  ],
  mapsEmbed:
    "https://www.google.com/maps?q=Via+Inghilterra+39,+57128+Livorno+LI,+Italia&output=embed",
  mapsDirections:
    "https://www.google.com/maps/dir/?api=1&destination=Via+Inghilterra+39,+57128+Livorno",
  years: 30,
};

export const NAV = [
  { label: "Home", href: "/" },
  {
    label: "Abbigliamento",
    href: "/abbigliamento",
    children: [
      { label: "Donna", href: "/abbigliamento-donna-livorno" },
      { label: "Uomo", href: "/abbigliamento-uomo-livorno" },
      { label: "Neonato", href: "/abbigliamento-neonato-livorno" },
    ],
  },
  {
    label: "Servizi",
    href: "/servizi",
    children: [
      { label: "Lavanderia", href: "/lavanderia-livorno" },
      { label: "Stireria", href: "/stireria-livorno" },
      { label: "Sartoria", href: "/sartoria-livorno" },
      { label: "Prodotti", href: "/prodotti-bucato-livorno" },
    ],
  },
  { label: "Occasioni", href: "/occasioni" },
  { label: "Foto", href: "/foto" },
  { label: "Feste", href: "/feste" },
  { label: "Contatti", href: "/contatti" },
];
